import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TalkToExpert from "../components/LandingPage/TalkToExpert";
import Testmonials from "../components/LandingPage/Testmonials";
import OtherLayout from "../components/Layout/OtherLayout";
import axios from "axios";
import noresult from "../images/noresult.png";
import "../Style/CategoryListPage/Category.css";
import SiteReviews from "../components/SiteReviews";
import PlaceSharpIcon from "@mui/icons-material/PlaceSharp";
import CalendarMonthSharpIcon from "@mui/icons-material/CalendarMonthSharp";
import AccessTimeSharpIcon from "@mui/icons-material/AccessTimeSharp";
import Layout from "../components/Layout/HomeLayout";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Faq from "../components/Faq";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import HomeBlogs from "../components/LandingPage/HomeBlogs";
import Form from "../components/Contact/Form";

import TripSlider from "../components/TripDetails/TripSlider";
// ✅ Fix relative image paths (backend returns "tripimage/xyz.jpg")
const fixImageUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `https://highmountains.in/${url.replace(/\\/g, "/")}`;
};

const CategoryListPage = () => {
  const [allTrips, setAllTrips] = useState([]);
  const [filteredTrips, setFilteredTrips] = useState([]);  const [privateTrips, setPrivateTrips] = useState([]); // ✅ new state

  const [communityTrips, setCommunityTrips] = useState([]); // ✅ new state
  const [categoryBackground, setCategoryBackground] = useState(null);

  const [monthFilter, setMonthFilter] = useState("all");
  const [durationFilter, setDurationFilter] = useState("all");

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isExpanded, setIsExpanded] = useState(false);
  const params = useParams();
  const navigate = useNavigate();
  const paramscategory = params?.category;

  document.title = `High Mountains - ${paramscategory}`;
const [activeTab, setActiveTab] = useState("india");const indiaCategories = [
  "Community Trips", 
  "Weekend Getaways",
  "Andaman and Nicobar",
  "Goa",
  "Himachal Pradesh",
  "Kargil",
  "Karnataka",
  "Kashmir",
  "Kerala",
  "Lahaul",
  "Lakshadweep",
  "Leh Ladakh",
  "Meghalaya",
  "Rajasthan", 
  "Sikkim",
  "Spiti Valley",
  "Uttarakhand",

//  "NYE India Trips",
//  "NYE Community Trip",
//  "Customised Trips",
//   "Backpacking Trips",
// "NYE",
// "Land Packages",
// "Bike Trips",
// "Road Trips",
// "Winter Trips", 
// "Summer Trips",

];

const worldCategories = [
 "Azerbaijan",
  "Bali",
  "Bhutan",
  "Dubai",
  "Georgia",
  "Ibiza",
  "Iceland",
  "Kazakhstan",
   "Kenya",
  "Maldives",
    "Nepal",
   "Oman",
   "Philippines",
   "Sri Lanka",
   "Tanzania",
  "Thailand",
   "Turkey",
   "Vietnam",
   "NYE International Trips",
   "International Trips",

];
useEffect(() => {
  if (paramscategory) {
    const catLower = paramscategory.toLowerCase();

    if (indiaCategories.some(c => c.toLowerCase() === catLower)) {
      setActiveTab("india");
    } else if (worldCategories.some(c => c.toLowerCase() === catLower)) {
      setActiveTab("world");
    }
  }
}, [paramscategory]);



  

  // ✅ Fetch all trips and filter by category + community trips
  useEffect(() => {
    axios
      .get("api/trips/get-all-trips")
      .then((res) => {
        const trips = res.data.data || [];
        setAllTrips(trips);

        const cat = paramscategory?.toLowerCase();

        if (cat === "all") {
          setFilteredTrips(trips);
        } else {
          const filtered = trips.filter((trip) => {
            const categories = trip?.category?.map((c) => c.toLowerCase()) || [];
            const location = trip?.location?.toLowerCase() || "";
            return categories.includes(cat) || location.includes(cat);
          });
          setFilteredTrips(filtered);
        }

        // ✅ Community trips logic
        const commTrips = trips.filter((trip) => {
          const categories = trip?.category?.map((c) => c.toLowerCase()) || [];
          return (
            categories.includes("community trips") && categories.includes(cat)
          );
        });
        setCommunityTrips(commTrips);// ✅ Customized (Private) trips logic
        const privTrips = trips.filter((trip) => {
          const categories = trip?.category?.map((c) => c.toLowerCase()) || [];
          return (
            categories.includes("customised trips") && categories.includes(cat)
          );
        });
        setPrivateTrips(privTrips);
      })
      .catch((err) => console.error("Error fetching trips:", err));
  }, [paramscategory]);

  // ✅ Fetch category background/details
  const getAllCategory = async () => {
    try {
      const response = await axios.get(`api/category/get-all-category`);
      const categories = response.data.data;
      if (categories) {
        const image = categories?.filter(
          (category) => category.name === paramscategory
        );
        if (image && image.length > 0) {
          setCategoryBackground(image[0]);
        }
      }
    } catch (err) {
      console.log("Error fetching categories:", err);
    }
  };

  useEffect(() => {
    if (paramscategory) {
      getAllCategory();
    }
    // eslint-disable-next-line
  }, [paramscategory]);

  // Month & Duration filter options
  const monthNames = [
    "January","February","March","April","May","June",
    "July","August","September","October","November","December",
  ];

  const monthOptions = [
    ...new Set(
      filteredTrips?.flatMap((item) =>
        item.dates?.map((date) => date.date?.slice(5, 7))
      )
    ),
  ]?.map((month) => <option value={month}>{monthNames[month - 1]}</option>);

  const durationOptions = [
    ...new Set(filteredTrips?.map((item) => item.duration)),
  ]
    ?.sort((a, b) => {
      const [nightsA, daysA] = a?.split("N-");
      const [nightsB, daysB] = b?.split("N-");
      if (parseInt(nightsA) !== parseInt(nightsB)) {
        return parseInt(nightsA) - parseInt(nightsB);
      } else {
        return parseInt(daysA) - parseInt(daysB);
      }
    })
    ?.map((duration) => <option value={duration}>{duration}</option>);

  // Apply filterData
  function filterData() {
    return filteredTrips?.filter((item) => {
      if (monthFilter !== "all") {
        if (
          !item.dates.some(
            (dateObj) =>
              new Date(dateObj.date).getMonth() === parseInt(monthFilter) - 1
          )
        ) {
          return false;
        }
      }
      if (durationFilter !== "all" && item.duration !== durationFilter) {
        return false;
      }
      return true;
    });
  }

  const filteredData = filterData();

  // Utility: minimum base price
  const getMinBasePrice = (costingArray) => {
    if (!Array.isArray(costingArray)) return "0";

    let minPrice = Infinity;
    costingArray.forEach((entry) => {
      const heading = entry?.heading?.toLowerCase() || "";
      if (heading.includes("add on")) return;
      entry?.package?.forEach((pkg) => {
        const price = parseInt(pkg?.price);
        if (!isNaN(price) && price < minPrice) {
          minPrice = price;
        }
      });
    });
    return isFinite(minPrice) ? minPrice.toLocaleString("en-IN") : "0";
  };

  // Images from backend
  const images = categoryBackground?.bannerImages || [];
  const bannerImages = images.slice(0, 4);
  const extraImages = images.slice(4);
const tripSliderSettings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2 }
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 1 }
    }
  ]
};

  return (
    <Layout>
      {/* CATEGORY BANNER */}
      <div className="category-banner container-fluid">
        <div className="banner-grid">
          {/* LEFT SIDE */}
          <div className="banner-left">
            <div className="banner-left-top">
              {images[0] && (
<img src={fixImageUrl(images[0])} alt="banner1" className="banner-img small" />
              )}
              {images[1] && (
          <img src={fixImageUrl(images[1])} alt="banner2" className="banner-img small" />
              )}
            </div>
            <div className="banner-left-bottom">
              {images[2] && (
                <div
                  className="banner-more-wrapper"
                  onClick={() => {
                    setIsOpen(true);
                    setPhotoIndex(0);
                  }}
                >
            <img src={fixImageUrl(images[2])} alt="banner3" className="banner-img large" />
                  {images.length > 4 && (
                    <div className="banner-overlay">
                      +{images.length - 4} Photos
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="banner-right">
            {images[3] && (
             <img
          src={fixImageUrl(images[3])}
          alt="banner4"
          className="banner-img big"
                onClick={() => {
                  setIsOpen(true);
                  setPhotoIndex(3);
                }}
                style={{ cursor: "pointer" }}
              />
            )}
           <div className="banner-reviews">
  <SiteReviews
    variant="slider"     // 👈 This enables single-review auto slider mode
    hideHeading={true}   // 👈 You already want to hide heading
    limit={5}            // 👈 Optional: control number of reviews to rotate
  />
</div>

          </div>
        </div>
      </div>

      {/* ✅ LIGHTBOX MODAL */}
      {isOpen && (
        <Lightbox
          open={isOpen}
          close={() => setIsOpen(false)}
          index={photoIndex}
          slides={extraImages.map((src) => ({ src }))}
        />
      )}

      {/* CATEGORY OVERVIEW */}
      {categoryBackground?.overview && (
        <section className="overview-section">
          <div className="overview-card">
            <h3>
              About{" "}
              {paramscategory.charAt(0).toUpperCase() + paramscategory.slice(1)}
            </h3>
            {/* <p
              className={`overview-text ${isExpanded ? "expanded" : ""}`}
              style={{ whiteSpace: "pre-line" }}
            >
              {categoryBackground.overview}
            </p> */}
<div
  className={`overview-text ${isExpanded ? "expanded" : ""}`}
  dangerouslySetInnerHTML={{ __html: categoryBackground.overview }}
></div>
            {categoryBackground.overview.length > 200 && (
              <button
                className="read-more-button"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {isExpanded ? "Read Less" : "Read More"}
              </button>
            )}
          </div>
        </section>
      )}

    {/* CATEGORY FILTER BAR */}
<div className="category-page container-fluid my-4">
  <div className="row">
    {/* LEFT SIDEBAR */}
    <div className="col-12 col-md-3 category-sidebar">
      <h5 className="sidebar-title">Categories</h5>

      {/* Tabs */}
      <div className="tabs mb-3">
        <button
          className={`tab-btn ${activeTab === "india" ? "active" : ""}`}
          onClick={() => setActiveTab("india")}
        >
          Domestic
        </button>
        <button
          className={`tab-btn ${activeTab === "world" ? "active" : ""}`}
          onClick={() => setActiveTab("world")}
        >
          International
        </button>
      </div>

      {/* Sidebar List */}
      <div className="category-vertical-slider">
  {(activeTab === "india" ? indiaCategories : worldCategories).map((filter) => (
    <div
      key={filter}
      className={`sidebar-item ${
        paramscategory?.toLowerCase() === filter.toLowerCase() ? "active" : ""
      }`}
      onClick={() => navigate(`/category/${filter}`)}
    >
      {filter}
    </div>
  ))}
</div>

    </div>

    {/* RIGHT CONTENT */}
    <div className="col-12 col-md-9">
      {filteredTrips.length > 0 ? (
        <TripSlider trips={filteredTrips} />
      ) : (
        <p>No trips found for {paramscategory}</p>
      )}
    </div>
  </div>
</div>

      {/* ✅ COMMUNITY TRIPS SECTION */}
      {communityTrips.length > 0 && (
        <div className="category__cont container-fluid px-lg-5 px-4 Mon_font my-5">
          <h2 className="m-0 text-start text-lg-center category__heading mb-4 fw-bold">
            {paramscategory} Community Trips
          </h2>
          <div className="row">
            {communityTrips.map((item, index) => {
              const filterDate = item.dates.filter(
                (obj) => new Date(obj.date) >= new Date()
              );
              return (
                <div key={index} className="col-12 col-sm-12 col-md-4 col-lg-4">
                  <div
                    className="trip-container"
                    onClick={() =>
                      navigate(`/trip/${item.heading.replace(/\s+/g, "-")}`)
                    }
                  >
                    <div className="trip category-page-trip">
                      {item?.customised === "true" && (
                        <div className="customise-label">Customised</div>
                      )}
                      <div className="trip-price">
                        <b>
                          ₹{" "}
                          {item?.customised === "true"
                            ? getMinBasePrice(item?.hmCosting)
                            : getMinBasePrice(item?.costing)}
                        </b>
                      </div>
                      {item?.customised === "false" && (
                        <div
                          className={`spots-left ${
                            Number(item.spotsLeft) > 0
                              ? "spots-available"
                              : "spots-soldout"
                          }`}
                        >
                          {Number(item.spotsLeft) > 0
                            ? `${item.spotsLeft} Spot${
                                item.spotsLeft > 1 ? "s" : ""
                              } Left`
                            : "Sold Out"}
                        </div>
                      )}

                      <img
                        style={{ objectFit: "cover" }}
                        src={`https://highmountains.in/tripimage/${item?.image}`}
                        alt=""
                      />
                      <h5 className="mb-3">{item?.heading}</h5>
                      <div className="trip-det">
                        <p className="trip-dep">
                          <PlaceSharpIcon className="icon me-1" />
                          {item?.departure}
                        </p>
                        <p className="justify-content-end">
                          <AccessTimeSharpIcon className="icon me-1" />
                          {item?.duration}
                        </p>
                        <div className="w-100 d-flex mb-3">
                          {item?.customised === "false" && (
                            <div className="">
                              <CalendarMonthSharpIcon className="icon me-1" />
                            </div>
                          )}
                          {item?.customised === "false" &&
                          filterDate?.length !== 0 ? (
                            filterDate
                              .map((item) => (
                                <div className="me-2">
                                  <p className="m-0 w-100">
                                    {new Date(item.date).toLocaleDateString(
                                      "default",
                                      { day: "numeric", month: "short" }
                                    )}
                                    ,
                                  </p>
                                </div>
                              ))
                              .slice(0, 5)
                          ) : (
                            <div className="">
                              <CalendarMonthSharpIcon className="icon me-1" />
                              <small>Best Time - {item?.bestTime}</small>
                            </div>
                          )}
                        </div>
                      </div>
                      <button
                        onClick={() =>
                          navigate(`/trip/${item.heading.replace(/\s+/g, "-")}`)
                        }
                        className="w-100"
                      >
                        View Details
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
{/* ✅ CUSTOMISED TRIPS SECTION */}
{privateTrips.length > 0 && (
  <div className="category__cont container-fluid px-lg-5 px-4 Mon_font my-5">
    <h2 className="m-0 text-start text-lg-center category__heading mb-4 fw-bold">
      {paramscategory} Private Trips
    </h2>
    <div className="row">
      {privateTrips.map((item, index) => {
        const filterDate = item.dates.filter(
          (obj) => new Date(obj.date) >= new Date()
        );
        return (
          <div key={index} className="col-12 col-sm-12 col-md-4 col-lg-4">
            <div
              className="trip-container"
              onClick={() =>
                navigate(`/trip/${item.heading.replace(/\s+/g, "-")}`)
              }
            >
              <div className="trip category-page-trip">
                {item?.customised === "true" && (
                  <div className="customise-label">Customised</div>
                )}
                <div className="trip-price">
                  <b>
                    ₹{" "}
                    {item?.customised === "true"
                      ? getMinBasePrice(item?.hmCosting)
                      : getMinBasePrice(item?.costing)}
                  </b>
                </div>
                {item?.customised === "false" && (
                  <div
                    className={`spots-left ${
                      Number(item.spotsLeft) > 0
                        ? "spots-available"
                        : "spots-soldout"
                    }`}
                  >
                    {Number(item.spotsLeft) > 0
                      ? `${item.spotsLeft} Spot${
                          item.spotsLeft > 1 ? "s" : ""
                        } Left`
                      : "Sold Out"}
                  </div>
                )}

                <img
                  style={{ objectFit: "cover" }}
                  src={`https://highmountains.in/tripimage/${item?.image}`}
                  alt=""
                />
                <h5 className="mb-3">{item?.heading}</h5>
                <div className="trip-det">
                  <p className="trip-dep">
                    <PlaceSharpIcon className="icon me-1" />
                    {item?.departure}
                  </p>
                  <p className="justify-content-end">
                    <AccessTimeSharpIcon className="icon me-1" />
                    {item?.duration}
                  </p>
                  <div className="w-100 d-flex mb-3">
                    {item?.customised === "false" && (
                      <div className="">
                        <CalendarMonthSharpIcon className="icon me-1" />
                      </div>
                    )}
                    {item?.customised === "false" &&
                    filterDate?.length !== 0 ? (
                      filterDate
                        .map((d, i) => (
                          <div className="me-2" key={i}>
                            <p className="m-0 w-100">
                              {new Date(d.date).toLocaleDateString("default", {
                                day: "numeric",
                                month: "short",
                              })}
                              ,
                            </p>
                          </div>
                        ))
                        .slice(0, 5)
                    ) : (
                      <div className="">
                        <CalendarMonthSharpIcon className="icon me-1" />
                        <small>Best Time - {item?.bestTime}</small>
                      </div>
                    )}
                  </div>
                </div>
                <button
                  onClick={() =>
                    navigate(`/trip/${item.heading.replace(/\s+/g, "-")}`)
                  }
                  className="w-100"
                >
                  View Details
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>
)}
     

    {/* ✅ BLOGS BY CATEGORY */}
<div className="container-fluid px-lg-5 px-4 my-5">
  <HomeBlogs category={paramscategory} />
</div>

      <div className="my-5">
<SiteReviews variant="grid" />
      </div>     

      <Faq />
<h2 className="plan-trip-heading text-center">Plan Your Trip</h2>

<div className="customise-trip-form-wrapper">
  <div className="customise-trip-form-left">
<Form whiteBg={true} customiseMode={true} />
  </div>
  <div className="customise-trip-form-right">
    <img
      src="https://images.pexels.com/photos/287240/pexels-photo-287240.jpeg?cs=srgb"
      alt="Beautiful Destination"
      className="customise-trip-side-image"
    />
  </div>
</div>      
    </Layout>
  );
};

export default CategoryListPage;
